function parseSseEventData(data) {
  if (data == null || data === '') {
    return null;
  }
  let parsed = JSON.parse(data);
  if (typeof parsed === 'string') {
    try {
      parsed = JSON.parse(parsed);
    } catch (_) {
      /* 保持字符串 */
    }
  }
  return parsed;
}

/**
 * 默认仅 event: message（或省略 event）会走 onmessage。
 * 若服务端使用 event: business / data 等，必须 addEventListener，否则前端收不到。
 */
export function createReplyRecommendSse({ baseUrl, params, onOpen, onMessage, onError }) {
  const query = new URLSearchParams(params).toString();
  const source = new EventSource(`${baseUrl}/sse/stream?${query}`);

  const handleSseData = event => {
    try {
      const parsed = parseSseEventData(event.data);
      if (parsed != null && onMessage) {
        onMessage(parsed, event.type || 'message');
      }
    } catch (error) {
      if (onError) {
        onError(error);
      }
    }
  };

  source.onopen = event => {
    if (onOpen) {
      onOpen(event);
    }
  };

  source.onmessage = handleSseData;

  const namedEventTypes = ['business', 'data', 'push', 'im', 'qw', 'AI_RECOMMEND', 'im_common_message', 'qw_sse_detect'];
  namedEventTypes.forEach(type => {
    source.addEventListener(type, handleSseData);
  });

  source.onerror = error => {
    if (onError) {
      onError(error);
    }
  };

  return {
    close() {
      source.close();
    },
  };
}
